import React from 'react';
import withMultiverseApi from '../../hoc/multiverseApiProvider/withMultiverseApi';
import { MultiverseLocation, MultiverseRoom, MultiverseUser, WithMultiverseApiProps } from '../../hoc/multiverseApiProvider';
import BasicPage from '../../components/basicPage';
import PageTable from '../../components/pageTable';
import DriveBrowserBody from '../../components/driveBrowser/driveBrowserBody';
import { Card } from 'react-bootstrap';

type DomainSupportingDocsPageProps = {

} & WithMultiverseApiProps;

type DomainSupportingDocsPageState = {
    isLoading: boolean;
};


function SupportingDocsUploaderCard( props: DomainSupportingDocsPageProps ) {
    return (
        <Card className="mt-2 discovery-content-card d-flex flex-column h-100">
            <Card.Header>
                <Card.Title><b>Public Documents</b></Card.Title>
                <Card.Subtitle>Content in public documents is visible to every AI agent to share with any user.</Card.Subtitle>
            </Card.Header>
        <Card.Body>
        {props.multiverse.user?.id && props.domain?.domain &&
            <DriveBrowserBody 
                path={`/metaverses|${props.multiverse.user?.id}/${props.domain?.domain}`}
                documentsOnly={true}
                // onChangePath={(np) => this.setState({location: np})}
                // showDrivesList
                // showClose
                // onClose={this._handleCancel}
                // onSelectItem={this.props.onClickItem}
            />}
        </Card.Body>
        </Card>
    );
}



class _DomainSupportingDocsPage extends React.Component<DomainSupportingDocsPageProps, DomainSupportingDocsPageState> {

    
    render(): JSX.Element {
        return (
            <BasicPage title="Knowledge Base" className=' d-flex flex-column h-100'>
                <Card className="mb-2"><Card.Body>
                    <p><b> Manage the documents that power your Metaverse AI.</b></p>
                    <p>Documents uploaded to the public knowledge base are available to all AI Agents across the entire Multiverse platform. This enables them to answer questions, generate content and serve communities in any metaverse.</p>
                    <p><i>Upload concise docs, FAQs, or data sheets in markdown format for best results.</i></p>
                    <p><b>ONLY md, pdf or docx files are supported.</b></p>
                    </Card.Body></Card>
                {this.props.domain &&
                <SupportingDocsUploaderCard {...this.props}/>}
            </BasicPage>
        )
    }
}
export const DomainSupportingDocsPage = withMultiverseApi(_DomainSupportingDocsPage);

export default DomainSupportingDocsPage;
